/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Roles_ExtensionInputs */

const en_tables_roles_extension = /** @type {(inputs: Tables_Roles_ExtensionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extension`)
};

const de_tables_roles_extension = /** @type {(inputs: Tables_Roles_ExtensionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extension`)
};

/**
* | output |
* | --- |
* | "Extension" |
*
* @param {Tables_Roles_ExtensionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_roles_extension = /** @type {((inputs?: Tables_Roles_ExtensionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Roles_ExtensionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_roles_extension(inputs)
	return de_tables_roles_extension(inputs)
});